export var isBlurEvent = function isBlurEvent(prevFocusedState, focusedState) {
  return !!prevFocusedState && !focusedState;
};